import React from "react";
import { useTranslation } from "react-i18next";
import numeral from "numeral";
import NumberUtils from "util/NumberUtils";
const IndexSizeSummary = ({ index }) => {
  const { t } = useTranslation("indexsets");
  if (index.size) {
    return /* @__PURE__ */ React.createElement("span", null, t("index_summary.size", {
      size: NumberUtils.formatBytes(index.size.bytes),
      count: index.size.events,
      formattedCount: numeral(index.size.events).format("0,0")
    }), " ");
  }
  return /* @__PURE__ */ React.createElement("span", null);
};
export default IndexSizeSummary;
